export default "__VITE_ASSET__f2d42694__"